import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import enMessages from "./messages/en.json"
import ruMessages from "./messages/ru.json"

type Lang = "ru" | "en"

export const detectLang = (host: string): Lang => {
  const _host = host ? host : location.host
  return _host.includes("dabb.pro") || _host.includes("beaversbrothers.com") ? "en" : "ru"
}

export const i18n = (lng: Lang): void => {
  i18next.use(initReactI18next).init({
    lng,
    resources: {
      ru: {
        translation: ruMessages,
      },
      en: {
        translation: enMessages,
      },
    },
    returnEmptyString: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })
}
